<template>
  <v-flex>
    <credit-card-payer-info
      v-if="paymentMethodIsCreditCard"
    />
    <post-pay-payer-info
      v-else-if="paymentMethodIsPostPay"
    />
    <v-container
      v-else
      fluid
    >
      <v-row
        class="ma-0"
      >
        <empty-state
          color="primary"
        >
          <template v-slot:description>
            Nenhum método de pagamento selecionado
          </template>
        </empty-state>
      </v-row>
    </v-container>
  </v-flex>
</template>

<script>
  import CreditCardPayerInfo from "./CreditCardPayerInfo"
  import PostPayPayerInfo from "./PostPayPayerInfo"
  import {PAYMENT_METHOD} from "../../../helpers/payment/constants"
  import {isEqual} from "lodash/lang"
  import EmptyState from "../../Helpers/EmptyState"
  import {includes} from "lodash/collection"

  const _PaymentMixin = Symbol.for("_PaymentMixin")

  export default {
    name: "PayerInfo",
    inject: {_PaymentMixin},
    components: {EmptyState, PostPayPayerInfo, CreditCardPayerInfo},
    computed: {
      PaymentMixin() {
        return this._PaymentMixin()
      },
      paymentMethodIsCreditCard() {
        return includes([PAYMENT_METHOD.CREDIT_CARD, PAYMENT_METHOD.SAVED_CREDIT_CARD], this.PaymentMixin.paymentMethod)
      },
      paymentMethodIsPostPay() {
        return isEqual(this.PaymentMixin.paymentMethod, PAYMENT_METHOD.POST_PAY)
      }
    }
  }
</script>

<style scoped>

</style>
